'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.uploadFile = exports.UPLOAD_FILE = exports.saveTriple = exports.SAVE_TRIPLE = exports.saveEntity = exports.SAVE_ENTITY = exports.logout = exports.LOGOUT = exports.auth = exports.AUTH = undefined;

var _nthArg2 = require('lodash/nthArg');

var _nthArg3 = _interopRequireDefault(_nthArg2);

var _identity2 = require('lodash/identity');

var _identity3 = _interopRequireDefault(_identity2);

var _capeRedux = require('cape-redux');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AUTH = exports.AUTH = 'fire/AUTH';
var auth = exports.auth = (0, _capeRedux.noopAction)(AUTH);

var LOGOUT = exports.LOGOUT = 'fire/LOGOUT';
var logout = exports.logout = (0, _capeRedux.noopAction)(LOGOUT);

var SAVE_ENTITY = exports.SAVE_ENTITY = 'fire/SAVE_ENTITY';
var saveEntity = exports.saveEntity = (0, _capeRedux.createSimpleAction)(SAVE_ENTITY, _identity3.default, (0, _nthArg3.default)(1));

var SAVE_TRIPLE = exports.SAVE_TRIPLE = 'fire/SAVE_TRIPLE';
var saveTriple = exports.saveTriple = (0, _capeRedux.createSimpleAction)(SAVE_TRIPLE, _identity3.default, (0, _nthArg3.default)(1));

var UPLOAD_FILE = exports.UPLOAD_FILE = 'fire/UPLOAD_FILE';
var uploadFile = exports.uploadFile = (0, _capeRedux.createAction)(UPLOAD_FILE);


//////////////////
// WEBPACK FOOTER
// ./~/cape-redux-collection/~/cape-firebase/lib/actions.js
// module id = 363
// module chunks = 0